import { useCallback, useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

export default function useCourseSearch() {
  const [params, setParams] = useSearchParams();
  const query = params.toString();
  const update = useCallback((name, value, replace = false) => {
    setParams((current) => {
      const next = new URLSearchParams(current);
      if (value === "" || value == null) next.delete(name);
      else next.set(name, String(value));
      if (name !== "page") next.delete("page");
      return next;
    }, { replace });
  }, [setParams]);
  const updateFilters = useCallback((changes, replace = false) => {
    setParams((current) => {
      const next = new URLSearchParams(current);
      Object.entries(changes).forEach(([name, value]) => {
        if (value === "" || value == null) next.delete(name);
        else next.set(name, String(value));
      });
      if (!(Object.keys(changes).length === 1 && Object.prototype.hasOwnProperty.call(changes, "page"))) next.delete("page");
      return next;
    }, { replace });
  }, [setParams]);
  const reset = useCallback(() => setParams({}), [setParams]);
  return { params, query, update, updateFilters, reset };
}

// Draft input stays local; navigation replaces it and cancels pending edits.
export function useSearchDraft(value, commit) {
  const { key } = useLocation();
  const [draft, setDraft] = useState(value);
  useEffect(() => { setDraft(value); }, [value, key]);
  useEffect(() => {
    if (draft === value) return undefined;
    const timer = setTimeout(() => commit(draft.trim()), 350);
    return () => clearTimeout(timer);
  }, [draft, value, commit, key]);
  return [draft, setDraft];
}
